/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext } from "react";
import Layout from "components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import { useGetRoutes, useAutocompleteCIT } from "utils/apis/lookups.api";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { formatDate } from "date-fns";
import { useCreateCollectionOrder } from "utils/apis/collections.api";
import { PREV_5_DAY_DATE } from "utils/constant";
import { Link } from "react-router-dom";
import SearchableDropdown from "components/searchableDropdown";
import { UserContext } from "utils/reducers/user";

const formSchema = z.object({
  cashCenterId: z.string().min(1, { message: "Destination is required." }),
  customerId: z.string().min(1, { message: "Billing Customer is required." }),
  customerName: z.string().min(1, { message: "Billing Customer is required." }),
  servicePointId: z.string().min(1, { message: "Source is required." }),
  source: z.string().optional(),
  requestedBy: z.string().min(1, { message: "Requested By is required." }),
  serviceDateTime: z.date({
    required_error: "Service date is required.",
  }),
  serviceType: z.string(),
  invoicingModel: z.string(),
  priority: z.string().min(1, { message: "Job Priority is required." }),
  shift: z.string().min(1, { message: "Shift is required." }),
  jobNature: z.string(),
  jobType: z.string(),
  routeNo: z.string().optional(),
  remarks: z.string().optional(),
});

const jobPriorities = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];

const jobNatures = [
  {
    value: "Normal",
    name: "Normal",
  },
  {
    value: "Adhoc",
    name: "Adhoc",
  },
  {
    value: "Special Service",
    name: "Special Service",
  },
];

const jobTypes = [
  {
    value: "Cash Collection",
    name: "Cash Collection",
  },
];

const invoicingModels = [
  {
    value: "Fixed",
    name: "Fixed",
  },
  {
    value: "Dedicated",
    name: "Dedicated",
  },
  {
    value: "Service",
    name: "Service",
  },
];

export default function CreateCollection() {
  const { CashCenterId } = useContext(UserContext);
  const [sourceLocation, setSourceLocation] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");

  // 1. Define your form.
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      cashCenterId: CashCenterId || "",
      customerId: "",
      customerName: "",
      servicePointId: "",
      serviceType: "Collection",
      invoicingModel: "Service",
      priority: "2",
      jobNature: "Normal",
      shift: "morning",
      jobType: "Cash Collection",
      serviceDateTime: new Date(),
      routeNo: "",
      requestedBy: "",
      remarks: "",
    },
  });

  const { data: inRouteTeams } = useGetRoutes();

  const { data: autocompleteResults, isFetching: isFetchingAutocomplete } =
    useAutocompleteCIT(searchTerm);
  const {
    mutate: createCollectionOrder,
    isSuccess: isOrderSuccess,
    isPending: isOrderPending,
    isError: isOrderError,
    reset: orderReset,
  } = useCreateCollectionOrder();

  function onSubmit(values: z.infer<typeof formSchema>) {
    const source = sourceLocation?.locationName;
    const currentDate = new Date();
    const dateWithCurrentTime = new Date(values.serviceDateTime).setHours(
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds(),
      currentDate.getMilliseconds(),
    );

    const requestDto = {
      ...values,
      serviceDateTime: formatDate(
        dateWithCurrentTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
      source,
    };
    createCollectionOrder(requestDto);
  }

  const onSourceLocationChanged = (value: string) => {
    const ssp: any = autocompleteResults?.find(
      (sp: any) => String(sp.servicePointId) === value,
    );

    if (ssp) {
      setSourceLocation(ssp);
      form.setValue("customerId", ssp?.customerId);
      form.setValue("customerName", ssp?.customer);
    } else {
      setSourceLocation(null);
      form.setValue("routeNo", "");
    }
  };

  useEffect(() => {
    if (isOrderSuccess) {
      form.reset();
      setSearchTerm("");
      orderReset();
      setSourceLocation(null);
    }
    if (isOrderError) {
      orderReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSuccess, isOrderError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/collections">Collections</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Collection Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <div className="flex mx-4 mt-5 gap-3">
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Service Details</CardTitle>
            <CardDescription className="mt-3">
              <Form {...form}>
                <form
                  id="collection-form"
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="gap-8 grid grid-cols-2"
                >
                  <FormField
                    control={form.control}
                    name="servicePointId"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Source Location</FormLabel>

                        <SearchableDropdown
                          placeholder="Search Source Location"
                          value={field.value}
                          searchTerm={searchTerm}
                          onSearchChange={setSearchTerm}
                          data={
                            autocompleteResults?.map((item: any) => ({
                              value: item.servicePointId,
                              label: `${item.barcode || ""}-${item.locationId}`,
                            })) || []
                          }
                          loading={isFetchingAutocomplete}
                          onChange={(val) => {
                            field.onChange(val);
                            onSourceLocationChanged(val);
                          }}
                        />

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="customerName"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Customer</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Source Location"
                            readOnly
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="serviceDateTime"
                    render={({ field }) => (
                      <FormItem className="space-y-2">
                        <FormLabel>Service Date</FormLabel>
                        <DatePicker
                          {...field}
                          placeholder="Pick a date"
                          selectedDate={field.value}
                          onSelectDate={field.onChange}
                          disabled={(date) => date < PREV_5_DAY_DATE}
                        />
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormSelect
                    form={form}
                    data={invoicingModels}
                    name="invoicingModel"
                    label="Invoicing Model"
                    placeholder="Select Invoicing Model"
                  />
                  <FormSelect
                    form={form}
                    data={jobPriorities}
                    name="priority"
                    label="Job Priority"
                    placeholder="Select Job Priority"
                  />
                  <FormSelect
                    form={form}
                    data={jobTypes}
                    name="jobType"
                    label="Job Type"
                    placeholder="Select Job Type"
                  />
                  <FormSelect
                    form={form}
                    data={jobNatures}
                    name="jobNature"
                    label="Job Nature"
                    placeholder="Select Job Nature"
                  />

                  <FormCombobox
                    form={form}
                    data={inRouteTeams?.map((m: any) => ({
                      value: String(m.routeNo),
                      label: `${m.routeNo} (${m.description})`,
                    }))}
                    name="routeNo"
                    label="Route"
                    placeholder="Select Route"
                  />
                  <FormField
                    control={form.control}
                    name="requestedBy"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Requested By</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Requested By"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>Remarks</FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Write your remarks"
                            className="resize-none"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  {/* <Button type="submit">Submit</Button> */}
                </form>
              </Form>
            </CardDescription>
          </CardContent>
        </Card>
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Source Location</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationId || ""}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationName}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationType}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.routeNo || ""}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.siteLimit}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.serviceDays}
                  </div>
                </div>
              </div>
              <Button
                type="submit"
                form="collection-form"
                disabled={isOrderPending}
                isLoading={isOrderPending}
                variant="secondary"
                className="w-full mt-5"
              >
                Submit
              </Button>
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
